import { Component, computed, inject, input, output, signal } from '@angular/core';
import { PlayerControlsService } from 'player';
import { PlayerService } from '../../data-access/player.service';
import { RoundedIconButton } from 'app/shared/components/rounded-icon-button/rounded-icon-button';
import { SkinningService } from '@core/skin';
import { CommonModule } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';
import { TranscodeImageDirective } from '@shared/directives/transcode-image.directive';
import { PlayerTypes } from '../../data-access/player.config';
import { clpp } from '@castlabs/prestoplay';
import { tap } from 'rxjs';

@Component({
  selector: 'player-similar-content',
  imports: [
    CommonModule,
    RoundedIconButton,
    TranscodeImageDirective,
    TranslocoPipe
  ],
  templateUrl: './player-similar-content.component.html',
  styleUrl: './player-similar-content.component.scss'
})
export class PlayerSimilarContentComponent {
  private playerService = inject(PlayerService);
  public skinning = inject(SkinningService);
  public similarContent = input(null);
  public isMiniPlayer = signal(false);
  public isUiHidden = signal(false);
  public displaySimilarContent = computed(() => {
    const items = this.similarContent();
    const progress = this.playerService.getProgress()();
    const duration = this.playerService.getDuration();
    return Math.round((duration - progress)) <= 10 && !!items?.length;
  });

  public closeSimilarContent() {
    this.playerService.removeSimilarContentItems();
    if (this.playerService.getState()() == clpp.Player.State.ENDED) {
      this.playerService.close();
    }
  }

  public playSimilarContent(item) {
    this.playerService.release().pipe(
      tap(() => this.playerService.playItem(item, PlayerTypes.Normal)),
      tap(() => this.playerService.removeSimilarContentItems())
    ).subscribe()
  }

}
